import { render, staticRenderFns } from "./Aforos.vue?vue&type=template&id=46b206d2"
import script from "./Aforos.vue?vue&type=script&lang=js"
export * from "./Aforos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports